import Vue from 'vue'

const getDefaultState = () => {
  return {
    error: null,
    response: null,
    headerError: {
      message: '',
      urlName: '',
      urlLabel: '',
      closable: true
    }
  }
}

const state = getDefaultState()

const actions = {
  setError (context, error) {
    if (error.message === 'canceled') return

    // fix revoke loop on 403 forbidden access
    const { baseURL, url } = error.config
    const requestURL = new URL(`${baseURL}${url}`)
    const isFailedRevoke = requestURL.pathname.indexOf('revoke') >= 0
    // It's only in the case of an unconfirmed user that we don't logout
    if (
      error.response &&
      error.response.status === 401 &&
      !isFailedRevoke &&
      error.response.data.error !== 'unconfirmed.user'
    ) {
      context.dispatch('auth/logOut', null, { root: true })
    } else {
      context.commit('setError', error)
    }
  },

  setHeaderError (context, error) {
    context.commit('setHeaderError', error)
  },

  removeHeaderError (context) {
    context.commit('removeHeaderError')
  },

  resetState (context) {
    context.commit('resetState')
  }
}

const mutations = {
  setError (state, error) {
    state.response = error && error.response
    state.error = error
  },

  setHeaderError (state, error) {
    if (error.closable === undefined) {
      error.closable = true
    }
    state.headerError = error
  },

  removeHeaderError (state) {
    Vue.set(state, 'headerError', {})
  },

  resetState (state) {
    Object.assign(state, getDefaultState())
  }
}

const getters = {
  hasHeaderError: state => {
    return Boolean(state.headerError.message && state.headerError.message.length)
  }
}

export default () => ({
  namespaced: true,
  state,
  actions,
  mutations,
  getters
})
